export default __webpack_public_path__ + "static/media/icon-external-link.50ee9748.svg";